import React from "react";
import { SortEnd } from "react-sortable-hoc";

import { ItemLabel } from "../../../../../../App/Common/Components/FormComponents";
import { CheckBox } from "../../../../../pages/CourseAuthor/FormElements";
import ToggleDisplay from "../../../../../utils/ToggleDisplay";
import { AddOptionButton } from "./Choices.styles";
import { IChoicesProps } from "./Choices.types";
import { SortChoiceList } from "./SortableChoices";

export const ChoicesComponent: React.FC<IChoicesProps> = props => {
  const { enableEdit, exercise, operations, toggleRandomize, randomizeQuestionsCheckbox, randomize } = props;

  const sortEnd = (sort: SortEnd) => {
    if (sort.newIndex !== sort.oldIndex) {
      props.sortPartRequest({
        from: sort.oldIndex,
        itemId: exercise.id,
        to: sort.newIndex,
      });
    }
  };

  return (
    <>
      <SortChoiceList {...props} lockAxis="y" onSortEnd={sortEnd} useDragHandle={true} />
      <ToggleDisplay shouldDisplay={enableEdit}>
        <AddOptionButton onClick={operations.addChoiceExerciseItem}>Add Option</AddOptionButton>
      </ToggleDisplay>
      <ItemLabel htmlFor={randomizeQuestionsCheckbox} onClick={toggleRandomize}>
        <CheckBox checked={randomize} name={randomizeQuestionsCheckbox} type="checkbox" />
        Randomize the choices during learning
      </ItemLabel>
    </>
  );
};
